import {
  Dependent,
  DependentFitting,
  IFittedBrand,
  IFittingPreviewData,
  IPurchasesData,
} from '../../../../../../../graphql/lenses/models/get-lenses-preview.models';
import { SolutionsBrandType } from '../../../../../../../graphql/lenses/models/get-lenses.models';

export const filterPurchases = (purchases: IPurchasesData[]) => {
  let result: IPurchasesData[] = purchases || [];

  if (purchases?.length) {
    result = purchases.map(({ createdDateTime, type, scannedProduct }) => ({
      createdDateTime,
      type,
      scannedProduct: scannedProduct.filter(({
        myAcuvueBrandCode,
      }) => myAcuvueBrandCode !== SolutionsBrandType.arl),
    }));
  }

  return result.filter(({ scannedProduct }) => scannedProduct?.length);
};

export const filterFittings = (fittings: IFittingPreviewData[]) => {
  let result: IFittingPreviewData[] = fittings || [];

  if (fittings?.length) {
    result = fittings
      .map(({ createdDateTime, type, fittedBrands }) => ({
        createdDateTime,
        type,
        fittedBrands: fittedBrands.filter(({ brand }) => brand?.product !== SolutionsBrandType.arl),
      }));
  }

  return result;
};

export const filterDependentFittings = (dependents: Dependent[]): DependentFitting[] => {
  return dependents?.flatMap(({ dependentFittings }) =>
    dependentFittings
      ? dependentFittings?.map(({ id, consumerId, dependentId, createdDateTime, fitType, fittedBrands }) => ({
        id,
        consumerId,
        dependentId,
        createdDateTime,
        fitType,
        fittedBrands: fittedBrands?.filter(
          (brand: IFittedBrand) => brand?.product !== SolutionsBrandType.arl,
        ),
      }))
      : [],
  );
};
